<template>
  <div>
    <client-only v-if="$store.getters['UI/debug']">
      <ul class="debug__list">
        <li class="debug__item">
          <tree-view :data="basket" :options="{ rootObjectKey: 'Basket', maxDepth: 0, link: true }"> </tree-view>
        </li>
      </ul>
    </client-only>

    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="ee_element ee_spacer col-font-reset"
      ee-type="element"
      data-title="Spacer"
      style="font-size: 14px;text-align: left;min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td style="font-family: Arial, sans-serif;font-size: 1px;line-height: 1px">
            <img src="https://i.emlfiles4.com/cmpimg/t/s.gif" style="display: block; width: 1px; height: 15px;" alt="" class="" border="0" height="15" width="1" />
          </td>
        </tr>
      </tbody>
    </table>
    <table
      cellpadding="0"
      cellspacing="0"
      width="100%"
      class="ee_element ee_button"
      ee-type="element"
      data-title="Button"
      style="min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td class="element-pad button-container button-v2 root-element-pad button-center" style="font-family: Arial, sans-serif;padding: 10px 20px;text-align: center">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="button-wrapper col-font-reset"
              ee-template-version="2.4"
              style="font-size: 14px;text-align: center;min-width: auto;display: inline-block;float: none;margin: 0 auto;table-layout: auto"
            >
              <tbody>
                <tr>
                  <td
                    class="button-td"
                    style="font-family: Arial, sans-serif;border-radius: 3px;background: #333333;min-width: 0px;background-color: rgb(230, 0, 4)"
                    bgcolor="rgb(230, 0, 4)"
                  >
                    <p style="color: #ffffff;font-size: 14px;line-height: 19px;margin-bottom: 0;text-align: center;margin: 0px" class="ee_editable button-a">
                      <a
                        target="_blank"
                        class="product-url"
                        :href="abandonedBasketUrl"
                        style="word-wrap: break-word;word-break: break-word;color: #ffffff;text-align: center;display: block;height: 100%;font-family: Arial, sans-serif;font-size: 16px;font-style: normal;font-weight: bold;line-height: inherit;border: 0px solid #000000;border-radius: 3px;padding: 8px 15px;text-decoration: none;border-width: 0px;border-color: rgb(0, 0, 0);padding-top: 17px;padding-right: 15px;padding-bottom: 17px;padding-left: 15px"
                        ><font style="word-wrap: break-word;word-break: break-word;color: inherit"> Complete my order &gt;</font></a
                      >
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="ee_element ee_spacer col-font-reset"
      ee-type="element"
      data-title="Spacer"
      style="font-size: 14px;text-align: left;min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td style="font-family: Arial, sans-serif;font-size: 1px;line-height: 1px">
            <img src="https://i.emlfiles4.com/cmpimg/t/s.gif" style="display: block; width: 1px; height: 15px;" alt="" class="" border="0" height="15" width="1" />
          </td>
        </tr>
      </tbody>
    </table>

    <a
      v-for="(item, index) in basket?.items"
      :key="`AbandonedBasketItem${index}`"
      target="_blank"
      class="product-url"
      :href="`${$config.baseURL}${item?.url_path}`"
      style="text-decoration: none !important"
    >
      <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        align="center"
        width="100%"
        class="row ee_columns one-cols ee_element"
        ee-type="container"
        data-title="Columns"
        style="max-width: 660px;min-width: 100%;position: relative;background-color: rgb(255, 255, 255);table-layout: auto; justify-content: center;"
        bgcolor="rgb(255, 255, 255)"
      >
        <tbody>
          <tr>
            <td
              align="center"
              valign="top"
              class="row-inner f-size-0 element-pad"
              dir="ltr"
              style="font-family: Arial, sans-serif;font-size: 0;padding: 0 10px;border-width: 0;padding-top: 0px;padding-right: 10px;padding-bottom: 0px;padding-left: 10px"
            >
              <div
                class="stack-column stack-column-width"
                ee-percent-width="100.0000"
                style="width: 100%;display: inline-block;vertical-align: top;min-width: 100%;max-width: 640px"
              >
                <table cellspacing="0" cellpadding="0" border="0" width="100%" style="table-layout: auto;">
                  <tbody>
                    <tr>
                      <td dir="ltr" class="col-inner ee_dropzone" align="left" style="font-family: Arial, sans-serif;border-width: 0;padding: 0">
                        <table
                          width="100%"
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          class="col-font-reset ee_element ee_imageelement"
                          ee-type="element"
                          data-title="Image"
                          style="font-size: 14px;text-align: left;min-width: 100%;table-layout: auto"
                        >
                          <tbody>
                            <tr>
                              <td
                                class="element-pad element-bord"
                                style="font-family: Arial, sans-serif;padding: 10px;border-width: 0;padding-top: 10px;padding-right: 0px;padding-bottom: 10px;padding-left: 10px"
                              >
                                <center class="ved_ctr">
                                  <img
                                    :src="`${$config.imgixURL}${item?.image_path}?auto=forma&w=350`"
                                    :alt="item?.name || item?.title"
                                    style="color: #333333;font-size: 14px;line-height: 22px;height: auto;max-width: 250px;display: inline-block;margin: 0px;vertical-align: bottom;     border-radius: 7px;     box-shadow: 0 0 5px 0 rgba(0,0,0,.2);"
                                    class="ee_editable vedpw630"
                                    width="310"
                                  />
                                </center>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        cellpadding="0"
        cellspacing="0"
        class="col-font-reset ee_element ee_textelement"
        width="100%"
        ee-type="element"
        data-title="Text"
        style="font-size: 14px;text-align: left;min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
        bgcolor="rgb(255, 255, 255)"
      >
        <tbody>
          <tr>
            <td
              valign="top"
              align="left"
              class="element-pad element-bord root-element-pad"
              style="font-family: Arial, sans-serif;padding: 10px 20px;border-width: 0;padding-top: 10px;padding-right: 10px;padding-bottom: 10px;padding-left: 10px"
            >
              <div class="ee_editable" style="color: #333333;font-size: 14px;line-height: 22px">
                <p style="word-wrap: break-word;word-break: break-word;margin: 0px;line-height: 24px;text-align: center;font-family: arial, helvetica, sans-serif;font-size: 16px">
                  <b style="font-size: 16px; font-family: arial, helvetica, sans-serif;"
                    ><font style="word-wrap: break-word;word-break: break-word;font-size: 22px">{{ item?.name || item?.title }}<br /></font></b
                  ><b style="font-family: arial, helvetica, sans-serif;"
                    ><font style="word-wrap: break-word;word-break: break-word;font-size: 16px"><br />Offer:</font></b
                  ><font style="word-wrap: break-word;word-break: break-word;font-size: 16px;font-family: arial, helvetica, sans-serif"> {{ item?.offer?.name }}</font>
                </p>
                <p style="word-wrap: break-word;word-break: break-word;margin: 0px;line-height: 24px;text-align: center;font-size: 16px"><b>Quantity: </b>{{ item?.offer?.qty }}</p>
                <p style="word-wrap: break-word;word-break: break-word;margin: 0px;line-height: 22px;font-size: 18px">
                  <b></b>
                </p>
                <p style="word-wrap: break-word;word-break: break-word;margin: 0px;line-height: 22px;font-size: 18px">
                  <b></b>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </a>

    <table
      cellpadding="0"
      cellspacing="0"
      class="col-font-reset ee_element ee_textelement"
      width="100%"
      ee-type="element"
      data-title="Text"
      style="font-size: 14px;text-align: left;min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td
            valign="top"
            align="left"
            class="element-pad element-bord root-element-pad"
            style="font-family: Arial, sans-serif;padding: 10px 20px;border-width: 0;padding-top: 15px;padding-right: 10px;padding-bottom: 15px;padding-left: 10px;border-bottom: 1px solid rgb(0, 0, 0);border-top: 1px solid rgb(0, 0, 0)"
          >
            <div class="ee_editable" style="color: #333333;font-size: 14px;line-height: 22px">
              <p style="word-wrap: break-word;word-break: break-word;Margin: 0px;line-height: 22px;text-align: center">
                <b><font style="word-wrap: break-word;word-break: break-word;font-size: 22px">Order total:&nbsp;</font></b
                ><font style="word-wrap: break-word;word-break: break-word;font-size: 22px"
                  ><span class="price">£{{ basket?.totals?.total || '0.00' }}</span></font
                >
              </p>
              <p style="word-wrap: break-word;word-break: break-word;margin: 0px;line-height: 22px;font-size: 18px">
                <b></b>
              </p>
              <p style="word-wrap: break-word;word-break: break-word;margin: 0px;line-height: 22px;font-size: 18px">
                <b></b>
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="ee_element ee_spacer col-font-reset"
      ee-type="element"
      data-title="Spacer"
      style="font-size: 14px;text-align: left;min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td style="font-family: Arial, sans-serif;font-size: 1px;line-height: 1px">
            <img src="https://i.emlfiles4.com/cmpimg/t/s.gif" style="display: block; width: 1px; height: 10px;" alt="" class="" border="0" height="10" width="1" />
          </td>
        </tr>
      </tbody>
    </table>
    <table
      cellpadding="0"
      cellspacing="0"
      width="100%"
      class="ee_element ee_button"
      ee-type="element"
      data-title="Button"
      style="min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td class="element-pad button-container button-v2 root-element-pad button-center" style="font-family: Arial, sans-serif;padding: 10px 20px;text-align: center">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="button-wrapper col-font-reset"
              ee-template-version="2.4"
              style="font-size: 14px;text-align: center;min-width: auto;display: inline-block;float: none;margin: 0 auto;table-layout: auto"
            >
              <tbody>
                <tr>
                  <td
                    class="button-td"
                    style="font-family: Arial, sans-serif;border-radius: 3px;background: #333333;min-width: 0px;background-color: rgb(230, 0, 4)"
                    bgcolor="rgb(230, 0, 4)"
                  >
                    <p style="color: #ffffff;font-size: 14px;line-height: 19px;margin-bottom: 0;text-align: center;margin: 0px" class="ee_editable button-a">
                      <a
                        target="_blank"
                        class="product-url"
                        :href="abandonedBasketUrl"
                        style="word-wrap: break-word;word-break: break-word;color: #ffffff;text-align: center;display: block;height: 100%;font-family: Arial, sans-serif;font-size: 16px;font-style: normal;font-weight: bold;line-height: inherit;border: 0px solid #000000;border-radius: 3px;padding: 8px 15px;text-decoration: none;border-width: 0px;border-color: rgb(0, 0, 0);padding-top: 16px;padding-right: 28px;padding-bottom: 16px;padding-left: 28px"
                        ><font style="word-wrap: break-word;word-break: break-word;color: inherit"> Complete my order &gt;</font></a
                      >
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="ee_element ee_spacer col-font-reset"
      ee-type="element"
      data-title="Spacer"
      style="font-size: 14px;text-align: left;min-width: 100%;background-color: rgb(255, 255, 255);table-layout: auto"
      bgcolor="rgb(255, 255, 255)"
    >
      <tbody>
        <tr>
          <td style="font-family: Arial, sans-serif;font-size: 1px;line-height: 1px">
            <img src="https://i.emlfiles4.com/cmpimg/t/s.gif" style="display: block; width: 1px; height: 10px;" alt="" class="" border="0" height="10" width="1" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { AggregateBasketItemsWithTheSameSKU } from '~/lib/util/basket'
export default {
  name: 'AbandonedBasketById',
  serverCacheKey() {
    return false
  },
  layout: 'empty',

  async fetch() {
    try {
      // you could test if with a URL
      // http://localhost:3000/checkout/cart/77d1a704-5f7e-416a-ab36-79621dfccec6/VOC1
      console.log('ABANDONED_BASKET Entry Point')
      console.log('ABANDONED_BASKET params=', this.$route.params)

      const key = this.$route?.params?.key
      const id = this.$route?.params?.id
      const useCache = false

      this.basket = {}

      if (!Object.keys(this.$route.params).length) {
        return
      }
      if (!id || !key) {
        return
      }
      if (key !== this.$config.DotDigitalAbandonedBasketKey) {
        console.error(`ABANDONED_BASKET Key=${key} not valid`)
        return
      }

      console.log(`ABANDONED_BASKET id=${id} key=${key} useCache=${useCache}`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')

      // BASKET API
      console.info(`GET '${this.$config.AWSAPIGatewayURL}/basket/id/${id}'`)
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${this.$config.AWSAPIGatewayURL}/basket/id/${id}`,
        headers: {
          'x-api-key': this.$config.AWSAPIGatewayXAPIKEY,
          'Cache-Control': useCache ? 'max-age=3600' : 'max-age=0'
        }
      }

      this.basket = await this.$axios
        .request(config)
        .then(response => {
          const basket = AggregateBasketItemsWithTheSameSKU({ basket: response?.data?.payload })
          console.log('ABANDONED_BASKET OK basket=', basket)
          return basket
        })
        .catch(error => {
          console.log('ABANDONED_BASKET AXIOS error=', error)
          return {}
        })
      return true
    } catch (error) {
      console.log('ABANDONED_BASKET error=', error)
      this.basket = {}
      return false
    }
  },
  data() {
    return {
      basket: {}
    }
  },
  computed: {
    abandonedBasketUrl() {
      return `${this.$config.baseURL}/checkout/cart/${this.basket?.id}/${this.basket?.items[0]?.shortsite_code}`
    }
  }
}
</script>
<style lang="scss">
a:link {
  /* Applies to all unvisited links */
  text-decoration: none !important;
}
a:visited {
  /* Applies to all visited links */
  text-decoration: none !important;
}
a:hover {
  /* Applies to links under the pointer */
  text-decoration: none !important;
}
a:active {
  /* Applies to activated links */
  text-decoration: none !important;
}
</style>
